import {
  toastrErrorAlert,
  toastrSuccessAlert,
} from "components/Common/AlertToastr";
import { CommonButton } from "components/Common/ButtonCommon";
import HeaderCreateItem from "components/Common/HeaderCreateItem";
import Spacer from "components/Common/Spacing";
import { CommonText } from "components/Common/TextCommon";
import InputField from "components/form-control/InputField";
import Table from "components/form-control/Table";
import VVSSelectModel from "components/form-control/VVSSelectModel";
import {
  GET_CUSTOMERS,
  GET_EMPLOYEE,
  GET_EMPLOYEE_GROUP,
  GET_LEAD_ASSIGNMENT,
  LEAD_URL,
} from "helpers/url_helper";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import { Card, Col, Container, Row } from "reactstrap";
import httpService from "services/httpService";

const DEFAULT_TEAM_EMPOYEE = {
  team: "team",
  employee: "employee",
};

const HEADERS = [
  {
    text: "Nhóm sale",
    CellComponent: VVSSelectModel,
    cellComponentProps: (formValue, indexOfRow) => ({
      name: `tb_team.${indexOfRow}.team`,
      model: "EmployeeGroup",
      conditionField: {
        isActive: true,
      },
    }),
  },
  {
    text: "Số lượng phân bổ",
    CellComponent: InputField,

    cellComponentProps: (formValue, indexOfRow) => ({
      name: `tb_team.${indexOfRow}.quantity`,
      type: "number",
      min: 0,
    }),
  },
];

const HEADERS_EVEN = [
  {
    text: "Nhóm sale",
    CellComponent: VVSSelectModel,
    cellComponentProps: (formValue, indexOfRow) => ({
      name: `tb_team_even.${indexOfRow}.team`,
      model: "EmployeeGroup",
      disabled: true,
    }),
  },
  {
    text: "Số lượng phân bổ",
    CellComponent: InputField,
    cellComponentProps: (formValue, indexOfRow) => ({
      name: `tb_team_even.${indexOfRow}.quantity`,
      disabled: true,
      type: "number",
      min: 0,
    }),
  },
];

const HEADERS_EMPLOYEE_EVEN = [
  {
    text: "Tên nhân viên",
    CellComponent: VVSSelectModel,
    cellComponentProps: (formValue, indexOfRow) => ({
      name: `tb_employee_even.${indexOfRow}.name`,
      model: "EmployeeGroup",
      disabled: true,
    }),
  },
  {
    text: "Số lượng phân bổ",
    CellComponent: InputField,
    cellComponentProps: (formValue, indexOfRow) => ({
      name: `tb_employee_even.${indexOfRow}.quantity`,
      disabled: true,
      type: "number",
      min: 0,
    }),
  },
];

const HEADERS_EMPLOYEE_ANY = [
  {
    text: "Tên nhân viên",
    CellComponent: VVSSelectModel,
    cellComponentProps: (formValue, indexOfRow) => ({
      name: `tb_employee_any.${indexOfRow}.name`,
      model: "EmployeeGroup",
      disabled: true,
    }),
  },
  {
    text: "Số lượng phân bổ",
    CellComponent: InputField,
    cellComponentProps: (formValue, indexOfRow) => ({
      name: `tb_employee_any.${indexOfRow}.quantity`,
      type: "number",
      min: 0,
    }),
  },
];
const DEFAULT_ROW_VALUE = {};

const OPTION_ALLOTMENT = [
  {
    index: 1,
    title: "Phân bổ đều",
    value: "even",
  },
  {
    index: 2,
    title: "Phân bổ tuỳ chọn",
    value: "any",
  },
];

export default function AllotmentLead() {
  const { state } = useLocation();
  const [leads, setLeads] = useState([]);
  const [selectedOptionAllotMent, setSelectedOptionAllotment] = useState(null);
  const [selectedAllotmentTeamAEmployee, setSelectedAllotmentTeamAEmployee] =
    useState(DEFAULT_TEAM_EMPOYEE.team);

  const [employeeGroup, setEmployeeGroup] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState({});
  const [resLeadSalesTeam, setResLeadSalesTeam] = useState([]);

  useEffect(() => {
    //lead
    fetchLead(state.modelName);
    //employee group
    fetchEmployeeGroup();
    return;
  }, []);

  const isUnique = arr => {
    var tmpArr = [];
    for (var obj in arr) {
      if (tmpArr.indexOf(arr[obj].objectId) < 0) {
        tmpArr.push(arr[obj].objectId);
      } else {
        return arr[obj];
      }
    }
    return true;
  };

  const fetchLead = async modelName => {
    try {
      const res = await httpService.get(
        modelName === "Lead" ? LEAD_URL : GET_CUSTOMERS
      );
      setLeads(res.results.filter(item => !item?.salesTeam));
    } catch (error) {
      toastrErrorAlert("Đã xảy ra lỗi, vui lòng thử lại!!");
    }
  };

  const fetchEmployeeGroup = async () => {
    try {
      const res = await httpService.get(
        GET_EMPLOYEE_GROUP + `?where={"isActive": true }`
      );
      setEmployeeGroup(res.results);
    } catch (error) {
      toastrErrorAlert("Đã xảy ra lỗi, vui lòng thử lại!!");
    }
  };

  const formProps = useForm({
    mode: "onBlur",
  });

  const {
    formState: { errors },
    handleSubmit,
    setValue,
    reset,
  } = formProps;

  const onSubmit = async values => {
    if (!selectedOptionAllotMent) {
      toastrErrorAlert("Vui lòng chọn phân bổ theo hình thức: đều hoặc bất kỳ");
      return;
    }

    if (
      selectedAllotmentTeamAEmployee === DEFAULT_TEAM_EMPOYEE.team &&
      selectedOptionAllotMent === "even"
    ) {
      if (!leads.length) {
        toastrErrorAlert(
          "Số lượng khách hàng chưa được phân bổ là 0, bạn không thể phân bổ được. Vui lòng thử lại sau!."
        );
        return;
      }
      try {
        const tb_team_even_map = values.tb_team_even.map(item => {
          return {
            id: item.teamId,
            qty: item.quantity,
          };
        });

        const res = await httpService.post(GET_LEAD_ASSIGNMENT, {
          items: tb_team_even_map,
          isEmployee: false,
          modelName: state.modelName,
        });

        if (res.result?.status === 201) {
          toastrSuccessAlert("Phân bổ theo team thành công");
          fetchLead(state.modelName);
          return;
        }
        toastrErrorAlert("Đã xảy ra lỗi, vui lòng thử lại sau!!");
      } catch (error) {
        toastrErrorAlert("Đã xảy ra lỗi, vui lòng thử lại sau!!");
      }

      return;
    }

    if (
      selectedAllotmentTeamAEmployee === DEFAULT_TEAM_EMPOYEE.team &&
      selectedOptionAllotMent === "any"
    ) {
      if (!leads.length) {
        toastrErrorAlert(
          "Số lượng khách hàng chưa được phân bổ là 0, bạn không thể phân bổ được. Vui lòng thử lại sau!."
        );
        return;
      }
      const sumAmountAllotment = values.tb_team.reduce(
        (sum, item) => (sum += Number(item.quantity)),
        0
      );
      const checkUnique = isUnique(values.tb_team);

      if (checkUnique?.objectId) {
        toastrErrorAlert(
          `${checkUnique.team} đã bị trùng, ${checkUnique.team} phải là một hàng duy nhất.`
        );
        return;
      }

      if (sumAmountAllotment > leads.length) {
        toastrErrorAlert(
          `Số lượng phân bổ vượt quá số lượng chưa được phân bổ, vui lòng kiểm tra lại!`
        );
        return;
      }

      const tb_team_any_map = values.tb_team
        .filter(item => item.team !== "" && item.quantity !== "")
        .map(item => {
          return {
            id: item.objectId,
            qty: item.quantity !== "" ? Number(item.quantity) : 0,
          };
        });

      try {
        const res = await httpService.post(GET_LEAD_ASSIGNMENT, {
          items: tb_team_any_map,
          isEmployee: false,
          modelName: state.modelName,
        });
        if (res.result?.status === 201) {
          toastrSuccessAlert("Phân bổ theo team thành công");
          fetchLead(state.modelName);
          setValue("tb_team", []);
          return;
        }
        toastrErrorAlert("Đã xảy ra lỗi, vui lòng thử lại sau!!");
      } catch (error) {
        toastrErrorAlert("Đã xảy ra lỗi, vui lòng thử lại sau!!");
      }
      return;
    }

    if (
      selectedAllotmentTeamAEmployee === DEFAULT_TEAM_EMPOYEE.employee &&
      selectedOptionAllotMent === "even"
    ) {
      if (resLeadSalesTeam.length === 0 || !selectedEmployee?.objectId) {
        toastrErrorAlert(
          !selectedEmployee?.objectId
            ? "Vui lòng chọn nhóm để phân bổ"
            : `Số lượng nhân viên phân bổ đã hết vui lòng kiểm tra lại!`
        );
        return;
      }
      try {
        const tb_employee_even_map = values.tb_employee_even.map(item => {
          return {
            id: item.employeeId,
            qty: Number(item.quantity),
          };
        });

        const res = await httpService.post(GET_LEAD_ASSIGNMENT, {
          items: tb_employee_even_map,
          isEmployee: true,
          modelName: state.modelName,
        });
        if (res.result?.status === 201) {
          fetchEmployeeByGroup(selectedEmployee, state.modelName);
          setEmployeeGroup(null);
          toastrSuccessAlert("Phân bổ thành công");
          return;
        }
        toastrErrorAlert("Đã xảy ra lỗi, vui lòng thử lại sau!!");
      } catch (error) {
        toastrErrorAlert("Đã xảy ra lỗi, vui lòng thử lại sau!!");
      }
      return;
    }
    const sumAmountAllotment = values.tb_employee_any.reduce(
      (sum, item) => (sum += Number(item.quantity)),
      0
    );
    if (
      sumAmountAllotment > resLeadSalesTeam.length ||
      resLeadSalesTeam.length === 0
    ) {
      toastrErrorAlert(
        ` ${
          !selectedEmployee?.objectId
            ? "Vui lòng chọn nhóm!"
            : sumAmountAllotment > resLeadSalesTeam.length
            ? "Số lượng nhân viên phân bổ vượt quá số lượng chưa được phân bổ"
            : "Số lượng nhân viên phân bổ đã hết"
        }`
      );
      return;
    }
    try {
      const tb_employee_any_map = values.tb_employee_any.map(item => {
        return {
          id: item.employeeId,
          qty: item.quantity !== "" ? Number(item.quantity) : 0,
        };
      });
      const res = await httpService.post(GET_LEAD_ASSIGNMENT, {
        items: tb_employee_any_map,
        isEmployee: true,
        modelName: state.modelName,
      });

      if (res.result?.status === 201) {
        fetchEmployeeByGroup(selectedEmployee, state.modelName);
        setEmployeeGroup(null);
        toastrSuccessAlert("Phân bổ thành công");
        return;
      }
      toastrErrorAlert("Đã xảy ra lỗi, vui lòng thử lại sau!!");
    } catch (error) {
      toastrErrorAlert("Đã xảy ra lỗi, vui lòng thử lại sau!!");
    }
  };

  useEffect(() => {
    setValue("select_employee_even", "");
    if (selectedOptionAllotMent === "even") {
      const amountEvenAllotment = leads.length / employeeGroup.length;
      const chunk = _.chunk(new Array(leads.length), amountEvenAllotment);
      const test = employeeGroup.map((item, index) => {
        return {
          index,
          team: item.name,
          teamId: item.objectId,
          quantity:
            chunk[index] !== undefined
              ? chunk.length > employeeGroup.length &&
                index === employeeGroup.length - 1
                ? Number(chunk[index].length + chunk[index + 1].length)
                : Number(chunk[index].length)
              : 0,
        };
      });
      setSelectedEmployee({});
      reset({ tb_team_even: test });
      return;
    }
    setSelectedEmployee({});
  }, [selectedOptionAllotMent]);

  useEffect(() => {
    if (selectedEmployee?.objectId) {
      fetchEmployeeByGroup(selectedEmployee, state.modelName);
    }
  }, [selectedEmployee, employeeGroup]);

  const fetchEmployeeByGroup = async (selectedEmployee, modelName) => {
    const res = await httpService.get(
      GET_EMPLOYEE +
        `?where={"group":{"__type":"Pointer","className":"EmployeeGroup","objectId":"${selectedEmployee?.objectId}"}}`
    );

    const resLeadSalesTeam = await httpService.get(
      modelName === "Lead"
        ? LEAD_URL +
            `?where={"salesTeam":{"__type":"Pointer","className":"EmployeeGroup","objectId":"${selectedEmployee?.objectId}"}}`
        : GET_CUSTOMERS +
            `?where={"salesTeam":{"__type":"Pointer","className":"EmployeeGroup","objectId":"${selectedEmployee?.objectId}"}}`
    );

    const filterSaleStaff = resLeadSalesTeam.results.filter(
      item => !item.salesStaff
    );

    setResLeadSalesTeam(filterSaleStaff);

    const employees = res.results;
    const amountEvenAllotment = filterSaleStaff.length / employees.length;
    const chunk = _.chunk(
      new Array(filterSaleStaff.length),
      amountEvenAllotment < 1 ? 1 : amountEvenAllotment
    );

    const employeeMap = employees.map((item, index) => {
      return {
        index,
        employeeId: item.objectId,
        name: item.fullName,
        quantity:
          chunk[index] !== undefined
            ? chunk.length > employees.length && index === employees.length - 1
              ? Number(chunk[index].length + chunk[index + 1].length)
              : Number(chunk[index].length)
            : 0,
      };
    });

    const employeeMapAny = employees.map((item, index) => {
      return {
        index,
        name: item.fullName,
        employeeId: item.objectId,
        quantity: "",
      };
    });

    if (selectedOptionAllotMent === "even") {
      reset({ tb_employee_even: employeeMap });
      return;
    }
    reset({ tb_employee_any: employeeMapAny });
  };

  return (
    <div className="page-content">
      <Container fluid>
        <form onSubmit={handleSubmit(onSubmit)}>
          <HeaderCreateItem title="Phân bổ">
            <CommonButton level={0} type="submit">
              Phân bổ
            </CommonButton>
          </HeaderCreateItem>
          <Card body>
            <CommonText>
              Số lượng khách hàng tiềm năng chưa được phân bổ:{" "}
              <strong className="text-danger">{leads.length}</strong>
            </CommonText>

            <Spacer size={20} />

            <div className="d-flex gap-3">
              <div className="form-check ">
                <input
                  type="radio"
                  id="radio5"
                  name="positions"
                  className="form-check-input"
                  value="toast-top-right"
                  defaultChecked
                  onClick={() => {
                    setSelectedAllotmentTeamAEmployee(
                      DEFAULT_TEAM_EMPOYEE.team
                    );
                  }}
                />
                <CommonText
                  className="form-check-label"
                  style={{ marginTop: 0 }}
                >
                  Phân bổ theo team
                </CommonText>
              </div>
              <div className="form-check ">
                <input
                  type="radio"
                  id="radio5"
                  name="positions"
                  className="form-check-input"
                  value="toast-top-right"
                  onClick={() => {
                    setSelectedAllotmentTeamAEmployee(
                      DEFAULT_TEAM_EMPOYEE.employee
                    );
                  }}
                />
                <CommonText
                  className="form-check-label"
                  style={{ marginTop: 0 }}
                >
                  Phân bổ nhân viên của team
                </CommonText>
              </div>
            </div>

            <CommonText>Hình thức phân bổ:</CommonText>
            <div className="d-flex gap-3 mt-3" style={{ alignItems: "center" }}>
              {OPTION_ALLOTMENT.map((item, index) => {
                return (
                  <div
                    key={index + "periods"}
                    onClick={() => setSelectedOptionAllotment(item.value)}
                    style={
                      selectedOptionAllotMent === item.value
                        ? {
                            border: "1px solid #118B42",
                            padding: "10px",
                            borderRadius: 8,
                            cursor: "pointer",
                            color: "#118B42",
                          }
                        : {
                            border: "1px solid #9095A6",
                            padding: "10px",
                            borderRadius: 8,
                            cursor: "pointer",
                            color: "#9095A6",
                          }
                    }
                  >
                    <p className="mb-0">{item.title}</p>
                  </div>
                );
              })}
            </div>

            {selectedAllotmentTeamAEmployee === "team" && (
              <>
                {selectedOptionAllotMent === "any" && (
                  <Row className="mt-3">
                    <CommonText className="mb-3 mt-0">
                      Danh sách nhóm sales phân bổ tuỳ chọn
                    </CommonText>

                    <Table
                      headers={HEADERS}
                      defaultRowValue={DEFAULT_ROW_VALUE}
                      formProps={{
                        errors,
                        ...formProps,
                      }}
                      name="tb_team"
                    />
                  </Row>
                )}

                {selectedOptionAllotMent === "even" && (
                  <Row className="mt-3">
                    <CommonText className="mb-3 mt-0">
                      Danh sách nhóm sales phân bổ đều
                    </CommonText>

                    <Table
                      headers={HEADERS_EVEN}
                      defaultRowValue={DEFAULT_ROW_VALUE}
                      formProps={{
                        errors,
                        ...formProps,
                      }}
                      name="tb_team_even"
                      disableAdd
                      disableDelete
                    />
                  </Row>
                )}
              </>
            )}

            {selectedAllotmentTeamAEmployee === "employee" && (
              <>
                {selectedOptionAllotMent === "any" && (
                  <Row className="mt-3">
                    <CommonText className="mb-3 mt-0">Chọn nhóm</CommonText>
                    <Col sm={4} className="mb-3">
                      <VVSSelectModel
                        model="EmployeeGroup"
                        name="select_employee_even"
                        placeholder="Chọn nhóm"
                        errors={errors}
                        onSelect={item => {
                          setSelectedEmployee(item);
                        }}
                        {...formProps}
                        conditionField={{
                          isActive: true,
                        }}
                      />
                    </Col>
                    <div className="d-flex justify-content-between">
                      <CommonText className="mb-3 mt-0">
                        Danh sách nhân viên phân bổ tuỳ chọn
                      </CommonText>
                      <CommonText className="mb-3 mt-0">
                        Nhân viên chưa được phân bổ:{" "}
                        <strong className="text-danger">
                          {" "}
                          {resLeadSalesTeam.length}
                        </strong>
                      </CommonText>
                    </div>
                    <Table
                      headers={HEADERS_EMPLOYEE_ANY}
                      defaultRowValue={DEFAULT_ROW_VALUE}
                      formProps={{
                        errors,
                        ...formProps,
                      }}
                      name="tb_employee_any"
                    />
                  </Row>
                )}
                {selectedOptionAllotMent === "even" && (
                  <Row className="mt-3">
                    <CommonText className="mb-3 mt-0">Chọn nhóm</CommonText>
                    <Col sm={4} className="mb-3">
                      <VVSSelectModel
                        model="EmployeeGroup"
                        name="select_employee_even"
                        placeholder="Chọn nhóm"
                        errors={errors}
                        onSelect={item => {
                          setSelectedEmployee(item);
                        }}
                        {...formProps}
                        conditionField={{
                          isActive: true,
                        }}
                      />
                    </Col>
                    <div className="d-flex justify-content-between">
                      <CommonText className="mb-3 mt-0">
                        Danh sách nhân viên phân bổ đều
                      </CommonText>
                      <CommonText className="mb-3 mt-0">
                        Nhân viên chưa được phân bổ:{" "}
                        <strong className="text-danger">
                          {" "}
                          {resLeadSalesTeam.length}
                        </strong>
                      </CommonText>
                    </div>

                    <Table
                      headers={HEADERS_EMPLOYEE_EVEN}
                      defaultRowValue={DEFAULT_ROW_VALUE}
                      formProps={{
                        errors,
                        ...formProps,
                      }}
                      name="tb_employee_even"
                      disableAdd
                      disableDelete
                    />
                  </Row>
                )}
              </>
            )}
          </Card>
        </form>
      </Container>
    </div>
  );
}
